import React from 'react';
import {tid} from '../../../../../testUtils';
import SideBarButtonItem from '../../../../layout/common/SideBarButtonItem';
import {SUBMODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import {ScenarioActionProps} from '../../../actionMenuTypes';
import useScenarioShareSideBarModal from './useScenarioShareSideBarModal';
import {Share16} from '@carbon/icons-react';

const ScenarioShareActionMenuButton: React.FC<Partial<ScenarioActionProps>> = (props) => {
  const {ModalComponent, openModal} = useScenarioShareSideBarModal(props);

  return (
    <>
      <SideBarButtonItem
        {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_EDIT)}
        disabled={!props.scenario}
        onClick={openModal}
        icon={<Share16 />}
        text="Share Instance"
      />
      {ModalComponent}
    </>
  );
};

export default ScenarioShareActionMenuButton;
